import { Link } from 'react-router-dom';
import products from '../../data/products';

export default function MarketingFooter() {
  return (
    <footer className="border-t border-hairline bg-ink-deep text-paper-dark-text">
      <div className="mx-auto w-full max-w-site px-6 py-16 md:px-10">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <img src="/logo/edai-mark-dark-transparent.svg" alt="" aria-hidden="true" className="mb-3 h-7 w-auto" />
            <p className="font-serif text-xl">EdAI Systems</p>
            <p className="mt-1 text-sm text-slate-dark-text">The Standard of Knowledge</p>
            <p className="mt-6 max-w-measure text-sm leading-relaxed text-slate-dark-text">
              Authority-derived content, transformed into every modality of medical education and assessment.
            </p>
          </div>
          <nav aria-label="Products">
            <p className="text-sm font-semibold">Products</p>
            <ul className="mt-4 space-y-2">
              {products.map((p) => (
                <li key={p.slug}>
                  <Link to={`/products/${p.slug}`} className="text-sm text-slate-dark-text transition-colors hover:text-paper-dark-text">
                    {p.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <nav aria-label="Company">
            <p className="text-sm font-semibold">Company</p>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/who-its-for" className="text-sm text-slate-dark-text transition-colors hover:text-paper-dark-text">
                  Who it’s for
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-slate-dark-text transition-colors hover:text-paper-dark-text">
                  About
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-slate-dark-text transition-colors hover:text-paper-dark-text">
                  Writing
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-slate-dark-text transition-colors hover:text-paper-dark-text">
                  Request a demo
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-slate-dark-text transition-colors hover:text-paper-dark-text">
                  Privacy
                </Link>
              </li>
            </ul>
          </nav>
        </div>
        <div className="mt-14 flex flex-col gap-2 border-t border-hairline-dark pt-8 text-xs text-slate-dark-text md:flex-row md:items-center md:justify-between">
          <p>EdAI Systems, Inc. | 677 Ala Moana Blvd, Suite 1011, Honolulu, HI 96813</p>
          <p>
            <a href="mailto:john@edaisystems.com" className="transition-colors hover:text-paper-dark-text">
              john@edaisystems.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
